import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import "./FooterComponent.css";

const FooterComponent = () => {
  return (
    <footer className="footer-container">
      <div className="footer-wrapper">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start mb-3 mb-md-0">
            <div className="d-flex gap-3">
              {/* Social Links */}
              <a
                href="https://www.facebook.com/cred.tech2020"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange"
              >
                <FaFacebookF size={32} />
              </a>
              <a
                href="https://x.com/tech_cred2020"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange"
              >
                <FaTwitter size={32} />
              </a>
              <a
                href="https://www.instagram.com/cred_tech2020/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange"
              >
                <FaInstagram size={32} />
              </a>
              <a
                href="https://www.linkedin.com/showcase/cred-tech2020/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange"
              >
                <FaLinkedinIn size={32} />
              </a>
              <a
                href="https://www.youtube.com/@cred_tech2020"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange"
              >
                <FaYoutube size={32} />
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
            <div className="d-flex flex-column flex-md-row gap-3 gap-md-4">
              <div className="d-flex align-items-center">
                <span className="me-2">•</span>
                <Link to="/terms-of-use" className="footer-link">
                  Terms of Use
                </Link>
              </div>
              <div className="d-flex align-items-center">
                <span className="me-2">•</span>
                <Link to="/privacy-policy" className="footer-link">
                  Privacy Policy
                </Link>
              </div>
               <div className="d-flex align-items-center">
                <span className="me-2">•</span>
                <Link to="/shipping-policy" className="footer-link">
                  Shipping Policy
                </Link>
              </div>
               <div className="d-flex align-items-center">
                <span className="me-2">•</span>
                <Link to="/refund-policy" className="footer-link">
                  Refund Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
